import { getSecure, setSecure, removeSecure } from "../utils/secureStorage";

export const setTokens = (token, customerCode, mobile, voucherCode, email, name) => {
  setSecure("token", token);
  setSecure("customerCode", customerCode);
  setSecure("mobile", mobile);
  setSecure("voucherCode", voucherCode);
  setSecure("email", email);
  // setSecure("name", name);
};

export const getToken = () => {
  return getSecure("token");
};

export const getCustomerCode = () => {
  return getSecure("customerCode");
};

export const getMobile = () => {
  return getSecure("mobile");
};

export const getVoucherCode = () => {
  return getSecure("voucherCode");
};

export const getEmail = () => {
  return getSecure("email");
};

export const getName = () => {
  return getSecure("name");
};

export const clearTokens = () => {
  removeSecure("token");
  removeSecure("customerCode");
  removeSecure("mobile");
  removeSecure("voucherCode");
  removeSecure("email");
};